(() => {
  'use strict';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  const localeRoot = window.DM?.routesRoot || window.Shopify?.routes?.root || '/';
  document.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && /^\/(pages|blogs|products|collections|policies)\//.test(url.pathname)) {
      link.href = localeRoot + url.pathname.slice(1) + url.search + url.hash;
    }
  });
  const text = window.DM?.strings || {};
  const localText = text.localization || {};
  document.querySelectorAll('form.dm-language-switch input[name="return_to"], form.dm-country-switch input[name="return_to"]').forEach(input => { input.value = location.pathname + location.search; });
  const emit = (name, detail = {}) => document.dispatchEvent(new CustomEvent(`dm:${name}`, { detail }));
  const dialogAnimations=new WeakMap(),dialogOpeners=new WeakMap();
  function stopDialogAnimation(dialog){dialogAnimations.get(dialog)?.cancel();dialogAnimations.delete(dialog);}
  function openDialog(dialog) {
    if(!dialog)return;if(dialog.open&&dialog.dataset.phase!=='leaving')return;
    stopDialogAnimation(dialog);document.querySelectorAll('dialog[open]').forEach(other=>{if(other!==dialog){stopDialogAnimation(other);other.close();}});
    if(!dialog.open){dialogOpeners.set(dialog,document.activeElement);dialog.showModal();}
    document.body.classList.add('modal-open');dialog.dataset.phase='entering';
    if(!motion.matches){const drawer=dialog.classList.contains('cart-drawer'),animation=dialog.animate([{opacity:0,transform:drawer?'translateX(38px) scale(.985)':'translateY(28px) scale(.965)'},{opacity:1,transform:'translate(0,0) scale(1)'}],{duration:620,easing:'cubic-bezier(.16,1,.3,1)'});dialogAnimations.set(dialog,animation);animation.finished.then(()=>{if(dialog.open)dialog.dataset.phase='open';}).catch(()=>{});}else dialog.dataset.phase='open';
    if(dialog.id==='dm-cart-drawer')loadDrawer(dialog);
  }
  function closeDialog(dialog){
    if(!dialog?.open||dialog.dataset.phase==='leaving')return;stopDialogAnimation(dialog);
    if(motion.matches){dialog.close();return;}dialog.dataset.phase='leaving';const drawer=dialog.classList.contains('cart-drawer');const animation=dialog.animate([{opacity:1,transform:'translate(0,0) scale(1)'},{opacity:0,transform:drawer?'translateX(22px) scale(.99)':'translateY(14px) scale(.98)'}],{duration:260,easing:'cubic-bezier(.4,0,.8,.4)'});dialogAnimations.set(dialog,animation);animation.finished.then(()=>{if(dialog.dataset.phase==='leaving')dialog.close();}).catch(()=>{});
  }
  window.DMDialogs={open:openDialog,close:closeDialog};
  let cartController;
  async function loadDrawer(dialog){
    cartController?.abort();const controller=cartController=new AbortController(),status=dialog.querySelector('[data-cart-status]'),content=dialog.querySelector('[data-cart-content]');dialog.dataset.loading='true';status.textContent=localText.cart_loading;content.replaceChildren();
    try{const response=await fetch(`${localeRoot}cart.js`,{headers:{Accept:'application/json'},signal:controller.signal});if(!response.ok)throw Error('cart');const cart=await response.json();if(controller.signal.aborted||!dialog.open)return;
      const money=value=>new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:cart.currency||'EUR'}).format(value/100);document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      status.textContent=cart.item_count?`${localText.cart_title} (${cart.item_count})`:'';
      if(!cart.item_count){const empty=document.createElement('p');empty.className='drawer-empty';empty.textContent=localText.cart_empty;content.append(empty);}
      const lines=document.createElement('div');lines.className='drawer-lines';content.append(lines);
      for(const item of cart.items||[]){const line=document.createElement('article');line.className=item.image?'drawer-item':'drawer-item drawer-item--text-only';if(item.image){const img=document.createElement('img');img.src=item.image;img.alt='';img.width=88;img.height=88;line.append(img);}const copy=document.createElement('div'),title=document.createElement('h3'),quantity=document.createElement('p'),price=document.createElement('p');title.textContent=item.product_title||item.title;quantity.textContent=`${localText.cart_quantity} ${item.quantity}`;price.textContent=money(item.final_line_price??item.line_price);copy.append(title,quantity,price);line.append(copy);lines.append(line);}
      for(const discount of cart.cart_level_discount_applications||[]){const row=document.createElement('div');row.className='drawer-total drawer-discount';const label=document.createElement('span'),amount=document.createElement('strong');label.textContent=`${localText.cart_discount}: ${discount.title}`;amount.textContent=`−${money(discount.total_allocated_amount)}`;row.append(label,amount);content.append(row);}
      if(cart.item_count){const total=document.createElement('div');total.className='drawer-total';const label=document.createElement('span'),amount=document.createElement('strong');label.textContent=localText.cart_subtotal;amount.textContent=money(cart.total_price);total.append(label,amount);content.append(total);if(dialog.dataset.paymentNote){const note=document.createElement('p');note.className='drawer-payment-note';note.textContent=dialog.dataset.paymentNote;content.append(note);}}
    }catch(error){if(error.name!=='AbortError')status.textContent=localText.cart_error;}finally{if(cartController===controller)dialog.dataset.loading='false';}
  }
  document.addEventListener('click', event => {
    const opener=event.target.closest('[data-dialog]');if(opener){event.preventDefault();openDialog(document.getElementById(opener.dataset.dialog));}
    const closer=event.target.closest('[data-close-dialog]');if(closer)closeDialog(closer.closest('dialog'));
    const anchor=event.target.closest('dialog a');if(anchor)closeDialog(anchor.closest('dialog'));
    const choice=event.target.closest('a[href$="#choisir"]');if(choice)emit('choose',{source:choice.closest('header')?'header':choice.closest('.hero')?'hero':'page'});
  });
  document.querySelectorAll('dialog').forEach(dialog=>{
    dialog.addEventListener('cancel',event=>{event.preventDefault();closeDialog(dialog);});
    dialog.addEventListener('close',()=>{stopDialogAnimation(dialog);delete dialog.dataset.phase;if(dialog.id==='dm-cart-drawer')cartController?.abort();if(!document.querySelector('dialog[open]')){document.body.classList.remove('modal-open');const focus=dialogOpeners.get(dialog);if(focus?.isConnected)focus.focus({preventScroll:true});}});
    dialog.addEventListener('click',event=>{const rect=dialog.getBoundingClientRect();if(event.target===dialog&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom))closeDialog(dialog);});
  });

  class DMProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.form.querySelector('[type="submit"]');
      this.label = this.button?.querySelector('[data-submit-label]');
      this.message = this.querySelector('[data-form-message]');
      this.select = this.form.querySelector('[name="id"]');
      this.select?.addEventListener('change', () => this.updateVariant());
      this.form.addEventListener('submit', event => this.submit(event));
    }
    updateVariant() {
      const option = this.select.selectedOptions?.[0];
      if (!option) return;
      const price = this.closest('[data-product-scope]')?.querySelector('[data-product-price]');
      if (price) {
        price.replaceChildren();
        if (option.dataset.compare) { const old = document.createElement('s'); old.textContent = option.dataset.compare; price.append(old); }
        price.append(document.createTextNode(option.dataset.price));
      }
      const gallery = this.closest('[data-product-scope]')?.querySelector('dm-gallery');
      if (gallery && option.dataset.variantImage) {
        const index = gallery.thumbs?.findIndex(thumb => thumb.dataset.gallerySrc === option.dataset.variantImage);
        if (index >= 0) gallery.show(index);
      }
      this.button.disabled = option.dataset.available !== 'true';
      if (this.label) this.label.textContent = this.button.disabled ? text.soldOut : (this.dataset.addLabel || text.add);
      if (this.message) this.message.textContent = '';
      if (this.dataset.updateUrl === 'true') {
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      }
    }
    async submit(event) {
      if (!window.fetch) return;
      event.preventDefault();
      if (this.busy || this.button.disabled) return;
      if (window.DM?.preview) {
        this.message.textContent = 'Prévisualisation locale : aucun panier réel n’est modifié. La commande sera testée sur le thème Shopify non publié.';
        return;
      }
      this.busy = true;
      this.button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.label.textContent = this.dataset.cartRedirect ? this.dataset.addLabel : text.adding;
      this.message.textContent = '';
      let added = false;
      try {
        const response = await fetch(`${localeRoot}cart/add.js`, { method: 'POST', body: new FormData(this.form), headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : text.error);
        added = true;
        emit('add_to_cart', { variantId: this.select?.value, quantity: 1 });
        if (this.dataset.cartRedirect) { window.location.assign(this.dataset.cartRedirect); return; }
        this.message.textContent = text.added;
        const dialog = document.getElementById('dm-cart-confirmation');
        if (dialog) { dialog.querySelector('[data-added-title]').textContent = data.product_title || data.title || text.added; openDialog(dialog); }
        try {
          const cartResponse = await fetch(`${localeRoot}cart.js`, { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; }); }
        } catch { /* The item was added. Do not invite a duplicate submission. */ }
      } catch (error) {
        this.message.textContent = error.message || text.error;
        emit('cart_error');
      } finally {
        if (!added || !this.dataset.cartRedirect) {
        this.busy = false;
        this.form.removeAttribute('aria-busy');
        this.button.disabled = false;
        this.label.textContent = this.dataset.addLabel || (added ? text.addAgain : text.add);
        }
      }
    }
  }
  if (!customElements.get('dm-product')) customElements.define('dm-product', DMProduct);

  class DMGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.image = this.querySelector('[data-gallery-image]');
      this.thumbs = [...this.querySelectorAll('[data-gallery-src]')];
      this.index = Math.max(0, this.thumbs.findIndex(x => x.getAttribute('aria-pressed') === 'true'));
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-src]');
        if (thumb) this.show(this.thumbs.indexOf(thumb));
        const step = event.target.closest('[data-gallery-step]');
        if (step) this.show(this.index + Number(step.dataset.galleryStep));
        if (event.target.closest('[data-zoom]')) {
          const dialog = document.getElementById('dm-zoom');
          if (!dialog) return;
          dialog.querySelector('img').src = this.image.src;
          dialog.querySelector('img').alt = this.image.alt;
          openDialog(dialog);
        }
      });
      this.querySelector('.gallery-thumbs')?.addEventListener('keydown', event => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.thumbs.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.show(next);
        this.thumbs[this.index]?.focus();
      });
    }
    show(index) {
      if (!this.thumbs.length) return;
      this.index = (index + this.thumbs.length) % this.thumbs.length;
      const active = this.thumbs[this.index];
      const is3d = active.dataset.galleryKind === '3d';
      const explore = this.querySelector('[data-gallery-explore]');
      if (explore) explore.hidden = !is3d;
      const zoom = this.querySelector('[data-zoom]');
      if (zoom) zoom.hidden = is3d;
      this.image.src = active.dataset.gallerySrc;
      this.image.removeAttribute('srcset');
      this.image.alt = active.dataset.galleryAlt || '';
      this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === active)));
      const counter = this.querySelector('[data-gallery-counter]');
      if (counter) counter.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.thumbs.length).padStart(2, '0')}`;
    }
  }
  if (!customElements.get('dm-gallery')) customElements.define('dm-gallery', DMGallery);

  // Native scrolling; one requestAnimationFrame per scroll event; no perpetual loop.
  let pending = false;
  function updateDay() {
    pending = false;
    const hero = document.querySelector('.hero');
    const method = document.getElementById('fonctionnement');
    const choice = document.getElementById('choisir');
    const footer = document.querySelector('.closing');
    const offer = document.querySelector('[data-home-offer]');
    const slot = document.querySelector('[data-home-offer-slot]');
    const film = document.getElementById('le-film');
    if (offer && slot && film) {
      const filmTop = film.getBoundingClientRect().top;
      const bottomInset = parseFloat(getComputedStyle(offer).bottom) || 20;
      const dockLine = innerHeight - bottomInset - offer.offsetHeight;
      const floating = slot.getBoundingClientRect().top > dockLine;
      const progress = motion.matches ? Number(filmTop < innerHeight * .8) :
        Math.max(0, Math.min(1, (innerHeight * .8 - filmTop) / (innerHeight * .3)));
      offer.dataset.floating = String(floating);
      offer.style.setProperty('--offer-opacity', progress.toFixed(4));
      offer.inert = floating && progress === 0;
      if (offer.inert) offer.setAttribute('aria-hidden', 'true');
      else offer.removeAttribute('aria-hidden');
    }
    if (motion.matches) { root.style.setProperty('--shadow-x', '-12px'); root.style.setProperty('--shadow-y', '8px'); return; }
    if (hero) {
      const progress = Math.max(0, Math.min(1, -hero.getBoundingClientRect().top / hero.offsetHeight));
      root.style.setProperty('--ring-dash', String(140 + progress * 115));
    }
    if (method && choice && footer) {
      const start = method.offsetTop;
      const end = Math.max(start + 1, footer.offsetTop);
      const day = Math.max(0, Math.min(1, (scrollY - start) / (end - start)));
      root.style.setProperty('--shadow-x', `${(-18 + day * 36).toFixed(1)}px`);
      root.style.setProperty('--shadow-y', `${(6 + Math.abs(day - .5) * 12).toFixed(1)}px`);
      root.style.setProperty('--sky-shift', `${(day * 18).toFixed(1)}px`);
    }
  }
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(updateDay); } };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  motion.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
